export default "__VITE_ASSET__NzgR5p8v__"